import { useState, useEffect, useContext } from "react"
import { getStoryblokApi } from "@storyblok/react"

import { ArticleTypeStoryToObject } from "../helpers/storyHelpers"
import { LanguageContext } from "../context/languagecontext"


function useSingleArticleTypeByDatasource(datasource, story_language) {
  const language = useContext(LanguageContext)
  const [type,setType] = useState()

  useEffect(()=>{
    if(datasource) {
      const storyblokApi = getStoryblokApi()
      storyblokApi.get("cdn/stories", { 
        version: process.env.STORYBLOK_API_CONTENT_VERSION,
        content_type: "articletype",
        filter_query: {
          "article_type": {
            in: datasource
          }
        }
      }).then(({ data })=>{
        if(data && data.stories && data.stories.length > 0) {
          let rightVersion = data.stories.find((s)=>{
            return s.full_slug.startsWith(story_language || language)
          })
          if(rightVersion) {
            setType(ArticleTypeStoryToObject(rightVersion))
          } else {
            rightVersion = data.stories.find((s)=>{ return s.full_slug.startsWith("en")})
            if(rightVersion) {
              setType(rightVersion)
            }
          }
        }
      }).catch((err)=>{
        console.error(err)
      })
    }
  },[datasource, language, story_language])

  return type
}

export { 
  useSingleArticleTypeByDatasource,
}
